import api from "./api";

const ProfileAPI = {
    updUserAvatar: (formData) => api.post("/profile/avatar", formData),
    getUserAvatar: () => api.get("/profile/avatar"),
};

export default ProfileAPI;